import { render } from "./ClusterView.vue?vue&type=template&id=2878dcfc&scoped=true"
import script from "./ClusterView.vue?vue&type=script&lang=js"
export * from "./ClusterView.vue?vue&type=script&lang=js"

import "./ClusterView.vue?vue&type=style&index=0&id=2878dcfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2878dcfc"]])

export default __exports__